import { render, staticRenderFns } from "./NewPasswordRequest.vue?vue&type=template&id=1d604483&"
import script from "./NewPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./NewPasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports